"use client";

import React from "react";
import { signOut } from "next-auth/react";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import Logout from "@mui/icons-material/Logout";
import { Menu, Stack, Divider, MenuItem, Button } from "@mui/material";
import AvatarBlock from "@onair/ui/avatar-block";
import confirm from "@onair/ui/dialog/confirmation";
import { AccountButton } from "./account-button";
import ButtonSignIn from "./button-signin";
import { useSession } from "next-auth/react";
import { ButtonNotification } from "../partials/button-notification";

interface HeaderRightProps {
	// prop: type
}

const HeaderRight: React.FC<HeaderRightProps> = () => {
	const session = useSession();

	const userProfile = session.data?.userProfile;
	const isLogedIn = Boolean(session.data);
	const handleLogout = React.useCallback(async () => {
		await confirm("Bạn có chắc chắn muốn đăng xuất không", {
			enableBackdropClick: true,
		}).then((response) => {
			if (response) signOut();
		});
	}, []);

	if (!isLogedIn) return <ButtonSignIn />;

	return (
		<Stack direction="row" spacing={{ xs: 0, sm: 1 }} alignItems="center">
			<ButtonNotification data-slot="notifications" />
			<PopupState variant="popover" popupId="demo-popup-popover">
				{(popupState) => (
					<div>
						<AccountButton
							{...bindTrigger(popupState)}
							avatar={userProfile?.avatar ?? ""}
							fullName={userProfile?.fullName ?? ""}
						/>
						<Menu
							id="account-menu"
							{...bindPopover(popupState)}
							slotProps={{
								paper: {
									elevation: 0,
									sx: {
										overflow: "visible",
										filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
										mt: 1.5,
										"&::before": {
											content: '""',
											display: "block",
											position: "absolute",
											top: 0,
											right: 14,
											width: 10,
											height: 10,
											bgcolor: "background.paper",
											transform: "translateY(-50%) rotate(45deg)",
											zIndex: 0,
										},
									},
								},
							}}
							transformOrigin={{
								horizontal: "right",
								vertical: "top",
							}}
							anchorOrigin={{
								horizontal: "right",
								vertical: "bottom",
							}}
						>
							<MenuItem>
								<AvatarBlock
									title={userProfile?.fullName!}
									subTitle={userProfile?.role}
									src={userProfile?.avatar!}
									size={50}
								/>
							</MenuItem>
							<Divider />
							<MenuItem onClick={handleLogout} sx={{ color: "red" }}>
								<Logout fontSize="small" sx={{ mr: 1 }} />
								Đăng xuất
							</MenuItem>
						</Menu>
					</div>
				)}
			</PopupState>
		</Stack>
	);
};

export default HeaderRight;
